/*
 * Copyright (c) 2026. Tooling Team
 */

import PropTypes from "prop-types";
import {
  formatMiProbabilityValue,
  getMiProbabilityValue,
} from "../../utils/formatters";

const MI_PROBABILITY_HIGHLIGHT_COLORS = {
  error: {
    backgroundColor: "#fdecea",
    color: "#7a271a",
  },
  warning: {
    backgroundColor: "#fff8db",
    color: "#6b4e00",
  },
  success: {
    backgroundColor: "#eaf7ed",
    color: "#1f5f37",
  },
};

const MI_PROBABILITY_CELL_STYLE = {
  fontWeight: 600,
  lineHeight: 1.3,
};

const MI_PROBABILITY_CELL_WRAPPER_STYLE = {
  alignItems: "center",
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "center",
  margin: "-4px -8px",
  minHeight: "calc(100% + 8px)",
  width: "calc(100% + 16px)",
};

const getHighlightStyle = (probability) => {
  if (probability < 0.75) return MI_PROBABILITY_HIGHLIGHT_COLORS.error;
  if (probability < 0.9) return MI_PROBABILITY_HIGHLIGHT_COLORS.warning;
  return MI_PROBABILITY_HIGHLIGHT_COLORS.success;
};

const MiProbabilityCell = (cell) => {
  const probability = getMiProbabilityValue(cell.getValue?.());
  const highlightStyle =
    probability === null ? {} : getHighlightStyle(probability);

  return (
    <div style={{ ...MI_PROBABILITY_CELL_WRAPPER_STYLE, ...highlightStyle }}>
      <span style={MI_PROBABILITY_CELL_STYLE}>
        {formatMiProbabilityValue(cell.getValue?.())}
      </span>
    </div>
  );
};

MiProbabilityCell.propTypes = {
  getValue: PropTypes.func,
  row: PropTypes.object,
  table: PropTypes.object,
};

export default MiProbabilityCell;
